import React from 'react';
import './ErrorPage.scss';
import Owl from '../UI/Graphics/Owl';
import { COLORS } from '../../constants/colors';

const ErrorPage = ({ message }) => (
  <div className="c-error-page background-color-gray">
    <div className="c-error-page__owl-container">
      <Owl color={COLORS.gray2} />
    </div>
    <div className="c-error-page__inner">
      <div className="c-error-page__message h3-roobert color-black">
        <p>{message}</p>
      </div>
    </div>
  </div>
);

export default ErrorPage;
